import styled from "styled-components";

const Font = styled.h1`
    font-family: 'Albert Sans', sans-serif;
    color: black;
`

export const T1 = styled(Font)`
font-weight: 700;
font-size: 44px;
`

export const T2 = styled(Font)`
font-weight: 700;
font-size: 35px;
`

export const T3 = styled(Font)`
font-weight: 700;
font-size: 25px;
`

export const T4 = styled(Font)`
font-weight: 700;
font-size: 20px;
`

export const S1 = styled(Font)`
font-weight: 500;
font-size: 35px;
`

export const S2 = styled(Font)`
font-weight: 500;
font-size: 26px;
`

export const S3 = styled(Font)`
font-weight: 500;
font-size: 22px;
`

export const S4 = styled(Font)`
font-weight: 500;
font-size: 18px;
`

export const B1 = styled(Font)`
font-weight: 400;
font-size: 25px;
`

export const B1T = styled(Font)`
font-weight: 300;
font-size: 25px;
`

export const B2 = styled(Font)`
font-weight: 400;
font-size: 20px;
`

export const B2T = styled(Font)`
font-weight: 300;
font-size: 20px;
`

export const B3 = styled(Font)`
font-weight: 400;
font-size: 16px;
`

export const B3T = styled(Font)`
font-weight: 300;
font-size: 16px;
`

export const B4 = styled(Font)`
font-weight: 400;
font-size: 12px;
`

export const B4T = styled(Font)`
font-weight: 300;
font-size: 12px;
`
